import { Navigate, Route } from 'react-router-dom';
import AppLayout from '../components/app/Layout';
import routerLinks from '../components/app/routerLinks';
const protectMe = (
  path,
  component,
  key,
  redirectRoute,
  loggedIn,
  user,
  accountTypesArr,
  withLayout = true,
  Children
) => {
  const renderElement = () => {
    if (loggedIn && user?.activated) {
      // return <AppLayout>{component}</AppLayout>;
      if (
        accountTypesArr?.length > 0 &&
        accountTypesArr.includes(user?.accountType)
      ) {
        if (withLayout) {
          return <AppLayout>{component}</AppLayout>;
        }
        return component;
      } else {
        return <Navigate to={routerLinks?.notFound} />;
      }
    }

    return (
      <Navigate to={redirectRoute ? redirectRoute : routerLinks?.signinPage} />
    );
  };

  return (
    <Route
      exact
      path={path}
      key={key}
      element={renderElement()}
      // element={
      //   loggedIn && user?.activated ? (
      //     accountTypesArr?.length > 0 &&
      //     accountTypesArr.includes(user?.accountType) ? (
      //       <AppLayout>{component}</AppLayout>
      //     ) : (
      //       <Navigate to={routerLinks?.notFound} />
      //     )
      //   ) : (
      //     <Navigate
      //       to={redirectRoute ? redirectRoute : routerLinks?.signinPage}
      //     />
      //   )
      // }
    >
      {Children}
    </Route>
    // <Route
    //   exact
    //   path={path}
    //   key={key}
    //   element={
    //     loggedIn && user?.activated ? (
    //       <AppLayout>{component}</AppLayout>
    //     ) : (
    //       <Navigate
    //         to={redirectRoute ? redirectRoute : routerLinks?.signinPage}
    //       />
    //     )
    //   }
    // />
  );
};

export default protectMe;
